import React from 'react';
import clsx from 'clsx';
import styles from './PillTooltip.module.scss';
export const PillTooltip = ({ className, text }) => {
    return (<div className={clsx(className !== null && className !== void 0 ? className : className, styles.pillTooltipWrapper)}>
      <div className={styles.icon}>
        <img src='https://www.haven.com/assets/icons/info-circle-blue.svg' alt=''/>
      </div>
      {text}
    </div>);
};
